import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export type AccountReport = {
	account: EntityWithName;
	currency: string;
	deposits: number;
	withdrawals: number;
	jackpots: number;
	bonuses: number;
	income: number;
	rtp: number;
	numberOfBets: number;
	incomeAllSources: number;
	rtpAllSources: number;
};

export const accountReportSchema: ZodType<AccountReport> = z.object({
	account: entityWithNameSchema,
	currency: z.string(),
	deposits: z.number(),
	withdrawals: z.number(),
	jackpots: z.number(),
	bonuses: z.number(),
	income: z.number(),
	rtp: z.number(),
	numberOfBets: z.number(),
	incomeAllSources: z.number(),
	rtpAllSources: z.number(),
});
